function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, React.createElement("path", {
  d: "M9.5,21H1V1H11V5.5a.5.5,0,0,0,.5.5H16v.5a.5.5,0,0,0,1,0v-1a.41.41,0,0,0,0-.19.36.36,0,0,0-.11-.16l-5-5A.36.36,0,0,0,11.69,0a.41.41,0,0,0-.19,0H.5A.5.5,0,0,0,0,.5v21a.5.5,0,0,0,.5.5h9a.5.5,0,0,0,0-1ZM12,1.71,15.29,5H12ZM15.5,12a2,2,0,1,0,2,2A2,2,0,0,0,15.5,12Zm0,3a1,1,0,1,1,1-1A1,1,0,0,1,15.5,15Zm4.33-3.5a2.49,2.49,0,0,0-2.16-1.25h0a2.49,2.49,0,0,0-4.32,0h0a2.48,2.48,0,0,0-2.15,1.25,2.51,2.51,0,0,0,0,2.5A2.47,2.47,0,0,0,12,17.35V23.5a.5.5,0,0,0,.82.38l2.68-2.23,2.68,2.23a.47.47,0,0,0,.32.12.54.54,0,0,0,.21-.05A.49.49,0,0,0,19,23.5V17.35A2.47,2.47,0,0,0,19.83,14,2.48,2.48,0,0,0,19.83,11.5ZM18,22.43l-2.18-1.81a.49.49,0,0,0-.64,0L13,22.43V17.7a1.77,1.77,0,0,0,.32.05h0a2.49,2.49,0,0,0,4.32,0h0A1.75,1.75,0,0,0,18,17.7Zm.83-8.12A1.5,1.5,0,0,1,19,16a1.47,1.47,0,0,1-1.52.73.5.5,0,0,0-.55.31,1.49,1.49,0,0,1-2.78,0,.52.52,0,0,0-.47-.32h-.08A1.47,1.47,0,0,1,12,16a1.5,1.5,0,0,1,.13-1.69.5.5,0,0,0,0-.62A1.5,1.5,0,0,1,12,12a1.47,1.47,0,0,1,1.52-.73.5.5,0,0,0,.55-.31,1.49,1.49,0,0,1,2.78,0,.5.5,0,0,0,.55.31,1.5,1.5,0,0,1,1.39,2.42A.48.48,0,0,0,18.83,14.31Z"
})));

var SvgCertificate = function SvgCertificate(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 20.17 24",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCertificate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/certificate.ec745206.svg";
export { ForwardRef as ReactComponent };